import { c as _c } from "react/compiler-runtime";
import { IconBook } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { JsonSchemaProperty } from "./types";
interface IntegrationOutputFieldsProps {
  resultFields: string[];
  resultRequiredFields: string[];
  resultProperties: Record<string, JsonSchemaProperty>;
}
export function IntegrationOutputFields(t0) {
  const $ = _c(16);
  const {
    resultFields,
    resultRequiredFields,
    resultProperties
  } = t0;
  if (resultFields.length === 0) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconBook className="h-5 w-5 text-green-600 dark:text-green-400" />;
    t2 = <h2 className="text-ds-text-primary text-lg font-semibold">Output</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = resultFields.length !== 1 ? "s" : "";
  let t4;
  if ($[2] !== resultFields.length || $[3] !== t3) {
    t4 = <div className="border-ds-border-default flex items-center gap-2 border-b pb-4">{t1}{t2}<Badge className="ml-1">{resultFields.length} field{t3}</Badge></div>;
    $[2] = resultFields.length;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== resultProperties || $[7] !== resultRequiredFields) {
    let t7;
    if ($[9] !== resultRequiredFields) {
      t7 = t8 => {
        const [fieldName, fieldSchema] = t8;
        const isRequired = resultRequiredFields.includes(fieldName);
        return <AccordionItem key={fieldName} value={fieldName} className="border-ds-border-default border-b last:border-b-0"><AccordionTrigger className="dark:hover:bg-ds-neutral-800/50 hover:bg-ds-surface-hover px-1 py-3 hover:no-underline"><div className="flex w-full items-center gap-3 pr-2"><code className="bg-ds-neutral-100 text-ds-text-secondary dark:bg-ds-neutral-800 rounded-md px-2 py-1 font-mono text-sm">{fieldName}</code>{isRequired && <span className="text-xs font-medium text-red-500">*</span>}<span className="label-xs">{fieldSchema.type || "string"}</span></div></AccordionTrigger><AccordionContent className="px-1 pb-3 pt-1"><div className="dark:bg-ds-neutral-800/30 space-y-3 rounded-lg bg-zinc-50 p-4">{fieldSchema.description && <p className="body-sm">{fieldSchema.description}</p>}{fieldSchema.format && <div className="label-xs">Format:{" "}<code className="shadow-ds-soft bg-ds-surface-card ml-1 rounded-md px-1.5 py-0.5 font-mono">{fieldSchema.format}</code></div>}{fieldSchema["x-semantic-type"] && <div className="label-xs">Semantic Type:{" "}<code className="shadow-ds-soft bg-ds-surface-card ml-1 rounded-md px-1.5 py-0.5 font-mono">{fieldSchema["x-semantic-type"]}</code></div>}{!fieldSchema.description && !fieldSchema.format && !fieldSchema["x-semantic-type"] && <p className="text-ds-text-disabled dark:text-ds-text-muted text-sm italic">No additional details available.</p>}</div></AccordionContent></AccordionItem>;
      };
      $[9] = resultRequiredFields;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = (Object.entries(resultProperties) as [string, JsonSchemaProperty][]).map(t7);
    $[6] = resultProperties;
    $[7] = resultRequiredFields;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div><Accordion type="multiple" defaultValue={t5}>{t6}</Accordion></div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t4 || $[14] !== t7) {
    t8 = <div>{t4}{t7}</div>;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
}